import Body from './Body';

const View = (props) => <Body {...props} />;

export default View;
